<div
  layout
  layout-full-width
  padding-tb-small-xxx
  padding-lr
  class="container"
  [class.editing]="editing()"
>
  <div class="label">
    {{ name() }}
  </div>
  <div class="value" layout-horizontal overflow-hidden padding-tb-small-xxx>
    @if (!editing()) {
      @if (field()?.length) {
        <div
          [rtTooltip]="tooltipText()"
          [rtTooltipEnabled]="tooltipEnabled()"
          rtTooltipPosition="right"
          min-width-0
          [attr.layout-horizontal]="displayInline() || null"
        >
          @for (fieldObj of field(); track fieldObj.value) {
            <div class="row" layout-horizontal layout-align-items-center>
              @if (fieldDisplayTpl()) {
                <ng-container
                  *ngTemplateOutlet="
                    fieldDisplayTpl()!;
                    context: { value: fieldObj.value, isValid: fieldObj.isValid }
                  "
                />
              } @else {
                {{ fieldObj.value }}
              }
              @if (copyable()) {
                <rt-icon-button
                  [rtTooltip]="'app.common.copy_to_clipboard' | translate"
                  (click)="copyToClipboard(fieldObj.value)"
                  variant="plain"
                  margin-left-small-x
                  iconName="content-copy"
                  shape="square"
                  size="small"
                >
                </rt-icon-button>
              }
            </div>
          }
        </div>
        @if (editable()) {
          <div class="edit-button">
            <rt-icon-button
              (click)="edit.emit()"
              iconName="edit"
              size="small"
              variant="plain"
              shape="square"
            ></rt-icon-button>
          </div>
        }
      } @else if (!field()?.length) {
        <div class="value" layout-horizontal layout-align-items-center>
          <rt-icon-button
            [disabled]="!editable()"
            [rtTooltip]="tooltipText()"
            [rtTooltipEnabled]="tooltipEnabled()"
            rtTooltipPosition="right"
            variant="plain"
            iconName="remove"
            shape="square"
            size="small"
            [class.disabled-with-tooltip]="tooltipEnabled()"
            (click)="editable() && edit.emit()"
          >
          </rt-icon-button>
          @if (editable()) {
            <div class="edit-button">
              <rt-icon-button
                (click)="edit.emit()"
                iconName="edit"
                size="small"
                variant="plain"
                shape="square"
              ></rt-icon-button>
            </div>
          }
        </div>
      }
    } @else {
      <ng-container *ngTemplateOutlet="fieldEditTpl()!" />
    }
  </div>
</div>
